import { Component } from "react";

// Components
import I18n from "Components/Elements/I18n";
import LineChart from "Components/Materials/Charts/LineChart";
import { EFrequency } from "Components/Elements/FrequencyPicker";
import { DashboardChartsDatas } from "Api/SmartSig/Dashboard";

type IProps = {
	frequency: EFrequency;
	data: DashboardChartsDatas;
};
type IState = {};

export default class AnchorRequests extends Component<IProps, IState> {
	override render() {
		return (
			<LineChart
				frequency={this.props.frequency}
				title={I18n.translate("pages.dashboard.widgets.anchor_requests")}
				data={{currentTotal: this.props.data.all.currentTotal, previousTotal: this.props.data.all.previousTotal, xaxis: this.props.data.xaxis}}
				qte={this.props.data.all.previousTotal.length > 0 ? this.props.data.all.previousTotal[this.props.data.all.previousTotal.length - 1]! : 0}
			/>
		);
	}

	override componentDidMount() {
		// TODO: Fetch data from API and pass it to the chart
	}
}
